var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCasesinline = function SvgCasesinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFD512",
    clipPath: "url(#build-cases)"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.3,
    stroke: "#FFD512",
    strokeWidth: 1.4,
    d: "M7.48 7.085 1.051 4.29l-.279.642.279-.642a.31.31 0 0 1-.185-.284.29.29 0 0 1 .176-.26l.01-.005L7.48.942a1.3 1.3 0 0 1 1.04 0h.002l6.426 2.787.01.004a.29.29 0 0 1 .175.265v.008a.31.31 0 0 1-.183.287L8.521 7.085a1.3 1.3 0 0 1-1.04 0ZM.773 4.933 7.2 7.727.167 4a1.01 1.01 0 0 0 .606.933Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.227 7.1-.827-.36a.667.667 0 1 0-.533 1.22L14 8l-5.733 2.507a.67.67 0 0 1-.534 0L2 8l.127-.053a.667.667 0 1 0-.534-1.22l-.826.36a.993.993 0 0 0 0 1.833l6.426 2.793a2 2 0 0 0 1.6 0L15.22 8.92a1.01 1.01 0 0 0 .613-.92.99.99 0 0 0-.606-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.227 11.067-.827-.36a.666.666 0 1 0-.533 1.22L14 12l-5.733 2.473a.67.67 0 0 1-.534 0L2 12l.127-.06a.667.667 0 1 0-.534-1.22l-.826.36a1.007 1.007 0 0 0-.435 1.469 1 1 0 0 0 .441.364l6.427 2.8a2 2 0 0 0 1.6 0l6.427-2.8a.99.99 0 0 0 .606-.913 1.01 1.01 0 0 0-.606-.933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "build-cases"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCasesinline;